import PropTypes from "prop-types";

export const protectedRoutePropTypes = {
  /** The React Component to render when shouldRender is true. */
  children: PropTypes.node.isRequired,

  /** URL path to redirect to when shouldRender is false. */
  redirectPath: PropTypes.string.isRequired,

  /** Determines redirect type: 'internal' or 'external'. */
  redirectType: PropTypes.oneOf(["internal", "external"]),

  /** Set to true to render children, false to redirect. */
  shouldRender: PropTypes.bool,
};
